const Module5Config = {
	day1: {
		learn: {
			video: 'Module5Videos/learn_day_1.mp4',
			song: 'appfiles/distance/school_photo_montage_music_1.m4a',
			json: 'appfiles/distance/school_photo_montage_data_1.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_day_1.mp4',
		},
		rewardOption1: 'TreeHouseRed',
		rewardOption2: 'TreeHouseBlue',
	},
	day2: {
		learn: {
			video: 'Module5Videos/learn_day_2.mp4',
			song: 'appfiles/distance/school_photo_montage_music_2.m4a',
			json: 'appfiles/distance/school_photo_montage_data_2.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_day_2.mp4',
		},
		rewardOption1: 'Swing',
		rewardOption2: 'TireSwing',
	},
	day3: {
		learn: {
			video: 'Module5Videos/learn_day_3.mp4',
			song: 'appfiles/distance/school_photo_montage_music_3.m4a',
			json: 'appfiles/distance/school_photo_montage_data_3.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_day_3.mp4',
		},
		rewardOption1: 'Ladder',
		rewardOption2: 'Stairs',
	},
	day4: {
		introVideo: 'Module5Videos/welcome_day_4.mp4',
		rewardOption1: 'ButterflyPink',
		rewardOption2: 'ButterflyBlue',
		photoTime: {
			video1: 'Module5Videos/photo_time_1.mp4',
			video2: 'Module5Videos/photo_time_2.mp4',
			video3: 'Module5Videos/photo_time_3.mp4',
		},
		singingTime: {
			intro: 'Module5Videos/singing_time.mp4',
			demoMusic: '',
			singAlongMusic: 'appfiles/distance/distance_student_singalong.m4a',
			instrumentalMusic: 'appfiles/distance/distance_student_instrumental.m4a',
			singingAlongVideo: 'appfiles/new_files/singingtime_distance_new.mp4',
			instrumentalVideo: 'appfiles/distance/singingtime_distance_karaoke.mp4',
		},
	},
	day5: {
		introVideo: 'Module5Videos/welcome_day_5.mp4',
		rewardOption1: 'TelescopeBlue',
		rewardOption2: 'TelescopeRed',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_5.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_intro_day_5.mp4',
			afterVideo: 'Module5Videos/celebrate_close_day_5.mp4',
			animal: true,
			text: 'Record yourself in an excited voice and say, "I believe in me!"',
			name: 'distance_celebration_surprise_5.mp4',
		},
	},
	day6: {
		rewardOption1: 'DuckWhite',
		rewardOption2: 'DuckColored',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_6.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_intro_day_6.mp4',
			afterVideo: 'Module5Videos/celebrate_close_day_6.mp4',
			animal: true,
			text: 'Record yourself in a funny voice and say, "I believe in me!"',
			name: 'distance_celebration_surprise_6.mp4',
		},
	},
	day7: {
		rewardOption1: 'Deer',
		rewardOption2: 'Doe',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_7.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_intro_day_7.mp4',
			afterVideo: 'Module5Videos/celebrate_close_day_7.mp4',
			animal: true,
			text: 'Record yourself singing, \n "I believe in me!"',
			name: 'distance_celebration_surprise_7.mp4',
		},
	},
	day8: {
		rewardOption1: 'BirdBlue',
		rewardOption2: 'BirdRed',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_8.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_intro_day_8.mp4',
			afterVideo: 'Module5Videos/celebrate_close_day_8.mp4',
			animal: true,
			text: 'Record yourself making a silly face and say, "I believe in me!"',
			name: 'distance_celebration_surprise_8.mp4',
		},
	},
	day9: {
		conclusionVideo: 'Module5Videos/closing.mp4',
		rewardOption1: 'HardHat',
		rewardOption2: 'Goggles',
		learn: {
			recording: 'userfiles/{student-id}/distance_play_day_music.m4a',
			video: 'influencers/{influencer-id}/close_affirmation.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			demoSong: 'appfiles/distance/distance_student_singalong.m4a',
			json: 'appfiles/distance/school_photo_montage_data_9.json',
		},
		celebrate: {
			video: 'Module5Videos/celebrate_intro_day_9.mp4',
			afterVideo: null,
			animal: true,
			text: 'Record yourself dancing and say, "I believe in me!"',
			name: 'distance_celebration_surprise_9.mp4',
		},
		surprise: {
			video: 'Module5Videos/surprise.mp4',
			song: 'appfiles/distance/distance_student_instrumental.m4a',
			slides: [
				'influencers/{influencer-id}/close_affirmation.mp4',
				'userfiles/{student-id}/distance_celebration_surprise_5.mp4',
				'userfiles/{student-id}/distance_smile.jpg',
				'influencers/{influencer-id}/distance_video_message.mp4',
				'userfiles/{student-id}/distance_celebration_surprise_8.mp4',
				'userfiles/{student-id}/distance_silly_photo_1.jpg',
				'userfiles/{student-id}/distance_celebration_surprise_9.mp4',
			],
		},
	},
}

export default Module5Config
